import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 默认简体中文，新功能文案同时提供英文翻译。
import zhCN from './locales/zh-CN/translation.json';
import enUS from './locales/en-US/translation.json';

const resources = {
  'en-US': {
    translation: enUS
  },
  'zh-CN': {
    translation: zhCN
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zh-CN',
    fallbackLng: 'zh-CN',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false,
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
    }
  });

// 固定 localStorage 为 zh-CN，避免旧值触发语言检测
if (typeof window !== 'undefined') {
  localStorage.setItem('i18nextLng', 'zh-CN');
}

export default i18n;
